import type { IIconTypes } from "@components/atoms/icons/types";
import type { IIconStyle } from "@components/icons";
import type { IFontSizeType } from "@constants";

export const fontSizeToPixel = (size: IFontSizeType): number => {
  switch (size) {
    case "micro":
      return 10;
    case "xs":
      return 12;
    case "sm":
      return 13;
    case "md":
      return 14;
    case "md-high":
      return 14;
    case "base":
      return 16;
    case "lg":
      return 18;
    case "xl":
      return 20;
    case "2xl":
      return 24;
    case "7xl":
      return 68;

    default:
      return 24;
  }
};

export const iconStyleMapper = (type: IIconTypes): IIconStyle => {
  if (type === "bold") {
    return "Bold";
  }
  if (type === "broken") {
    return "Broken";
  }
  if (type === "linear") {
    return "Linear";
  }
  if (type === "linear-duotone") {
    return "LineDuotone";
  }
  if (type === "bold-duotone") {
    return "BoldDuotone";
  }
  if (type === "outline") {
    return "Outline";
  }
  return "Bold";
};
